import e from "react";
import { ImageCarousel as D } from "../../../ImageCarousel/ImageCarousel.js";
import { LinkWrapper as H } from "../LinkWrapper/index.js";
import { returnImage as f } from "../../utils/returnImage.js";
const o = _ref => {
  let {
    showImageBlurBackground: r = !1,
    isCarrouselDisabled: a = !1,
    mode: t = "horizontal",
    imageBadge: l,
    images: i,
    showDisabledButton: n,
    adUrl: m,
    adUrlTarget: d = "_blank",
    imagesCount: s = 0,
    videoCount: g = 0,
    imageLoadingStrategy: u = "lazy",
    showImagesCounter: C = !0,
    showVideosCounter: p = !0,
    displayMoreContentOverlay: c,
    onClick: I,
    onAuxClick: h,
    previousImageHandler: k,
    nextImageHandler: y,
    imgOptimization: B,
    titleID: b,
    isSmallScreen: w
  } = _ref;
  return e.createElement(e.Fragment, null, e.createElement(H, {
    adUrl: m,
    adUrlTarget: d,
    onClick: I,
    onAuxClick: h,
    titleID: b
  }), e.createElement(D, {
    isSmallScreen: w && t === "horizontal",
    imageList: f(i, a),
    isCarrouselDisabled: a,
    totalCarouselImages: C ? s : 0,
    totalCarouselVideos: p ? g : 0,
    badge: l,
    showDisabledButton: n,
    loading: u,
    displayMoreContentOverlay: c,
    previousImageHandler: k,
    nextImageHandler: y,
    imgOptimization: B,
    showImageBlurBackground: r
  }));
};
o.displayName = "AdCardHead";
export { o as AdCardHead };